import { axiosInstance as request } from '@api/rest.service'

const api = '/departments'

/**
 * @description GET /departments
 * @returns {AxiosPromise<any>}
 */
export const GET_DEPARTMENTS = () => request.get(api)

/**
 * @description POST /departments
 * @returns {AxiosPromise<any>}
 */
export const CREATE_DEPARTMENT = payload => request.post(api, payload)

/**
 * @description PUT /departments/{id}
 * @returns {AxiosPromise<any>}
 */
export const UPDATE_DEPARTMENT = (id, payload) => request.put(`${api}/${id}`, payload)

/**
 * @description GET /departments/{id}
 * @returns {AxiosPromise<any>}
 */
export const GET_DEPARTMENT = id => request.get(`${api}/${id}`)

/**
 * @description GET /departments/{id}/delete-confirmation
 * @returns {AxiosPromise<any>}
 */
export const GET_DEPARTMENT_DELETE_CONFIRMATION = id => request.get(`${api}/${id}/delete-confirmation`)

/**
 * @description DELETE /departments/{id}
 * @returns {AxiosPromise<any>}
 */
export const DELETE_DEPARTMENT = id => request.delete(`${api}/${id}`)

/**
 * @description GET /departments/budget-year-columns
 * @returns {AxiosPromise<any>}
 */
export const GET_DEPARTMENTS_BUDGET_YEAR_COLS = () => request.get(`${api}/budget-year-columns`)

/**
 * @description GET /departments?include=budgets
 * @returns {AxiosPromise<any>}
 */
export const GET_DEPARTMENTS_WITH_BUDGETS = () => request.get(`${api}?include=budgets`)

/**
 * @description GET /departments/spend-overview?year={year}
 * @returns {AxiosPromise<any>}
 */
export const GET_DEPARTMENTS_SPEND_OVERVIEW_FOR_YEAR = year => request.get(`${api}/spend-overview?year=${year}`)

/**
 * @description GET /departments/budget-cost-scenarios-for-financial-period/{financialPeriodId}
 * @returns {AxiosPromise<any>}
 */
export const GET_BUDGET_COST_SCENARIOS_FOR_FP = financialPeriodId =>
  request.get(`${api}/budget-cost-scenarios-for-financial-period/${financialPeriodId}`)

/**
 * @description PUT /departments/{departmentId}/budget-scenario-percentage-for-financial-period/{financialPeriodId}
 * @returns {AxiosPromise<any>}
 */
export const UPDATE_BUDGET_SCENARIO_PERCENTAGE_FOR_FP = (depId, fpId, payload) =>
  request.put(`${api}/${depId}/budget-scenario-percentage-for-financial-period/${fpId}`, payload)

/**
 * @description PUT /departments/{departmentId}/cost-scenario-percentage-for-financial-period/{financialPeriodId}
 * @returns {AxiosPromise<any>}
 */
export const UPDATE_COST_SCENARIO_PERCENTAGE_FOR_FP = (depId, fpId, payload) =>
  request.put(`${api}/${depId}/cost-scenario-percentage-for-financial-period/${fpId}`, payload)

/**
 * @description PUT /departments/{departmentId}/budget-scenario-amount-for-financial-period/{financialPeriodId}
 * @returns {AxiosPromise<any>}
 */
export const UPDATE_BUDGET_SCENARIO_AMOUNT_FOR_FP = (depId, fpId, payload) =>
  request.put(`${api}/${depId}/budget-scenario-amount-for-financial-period/${fpId}`, payload)

/**
 * @description PUT /departments/{departmentId}/cost-scenario-amount-for-financial-period/{financialPeriodId}
 * @returns {AxiosPromise<any>}
 */
export const UPDATE_COST_SCENARIO_AMOUNT_FOR_FP = (depId, fpId, payload) =>
  request.put(`${api}/${depId}/cost-scenario-amount-for-financial-period/${fpId}`, payload)
